import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { WarningTriangle } from 'assets/icons';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';

const MFATooManyRequestsModal = ({ modalOpen, closeModal, content }) => (
  <StyledModal isOpen={modalOpen} closeModal={closeModal}>
    <div className="fl">
      <div className="mr-12">
        <WarningTriangle width={28} height={26} />
      </div>
      <div>
        <h3 className="ff-body fs-22 tc-main fw-600 lh-1-2 mb-16 mt-0">
          Too many verification codes have been sent
        </h3>
        <p className="ff-body fs-16 m-fs-16 tc-secondary lh-1-3">{content}</p>
      </div>
    </div>
    <div className="fl jc-fe ai-c mt-32 m-mt-40">
      <DismissButton
        type="button"
        handleClick={closeModal}
        label="Dismiss"
        className="cef-btn cef-btn--grey cef-btn--feature cef-ui__button width-100">
        OK
      </DismissButton>
    </div>
  </StyledModal>
);

const StyledModal = styled(Modal)`
  > div {
    padding: ${toRem(32)} ${toRem(16)};
    width: 80%;
    max-width: 500px;
    box-sizing: border-box;

    ${responsive('tabletSmall')} {
      padding: ${toRem(32)};
    }
  }
`;

const DismissButton = styled(Button)`
  max-width: 164px;
`;

export default MFATooManyRequestsModal;
